import FormattedMessage from 'I18n/components/FormattedMessage';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import styled from 'styled-components';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { AgentFilterControls } from './AgentFilterControls';
import { AppFilterControls } from './AppFilterControls';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { BreezeFilter } from './singleUseFilters/BreezeFilter';
import { PortalInstallableFilter } from './singleUseFilters/PortalInstallableFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAside = styled.aside.withConfig({
  displayName: "FilterPanel__StyledAside"
})(({
  theme: _theme,
  $open
}) => {
  const theme = _theme;
  return {
    marginInlineStart: $open ? theme.space['600'] : '0',
    opacity: $open ? 1 : 0,
    transition: 'opacity 0.3s linear'
  };
});
export function FilterPanel({
  open,
  onClose
}) {
  const {
    mobile,
    mobilePanelWidth
  } = useResponsiveProps({
    mobile: {
      xs: true,
      lg: false
    },
    mobilePanelWidth: {
      xs: undefined,
      sm: '400px'
    }
  });
  const searchParams = useSearchParams();
  if (mobile) {
    return open && /*#__PURE__*/_jsxs(ModalPanel, {
      width: mobilePanelWidth,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.filters.panelTitle"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        paddingBlockEnd: "1000",
        children: /*#__PURE__*/_jsx(FilterPanelContent, {})
      }), /*#__PURE__*/_jsx(DialogFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.filters.closePanel"
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(StyledAside, {
    $open: open,
    children: open && /*#__PURE__*/_jsx(CardWrapper, {
      compact: true,
      display: "flex",
      flexDirection: "column",
      gap: "400",
      inlineSize: "302px",
      marginBlockStart: searchParams.get('search') ? '1200' : '0',
      tabIndex: -1,
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsxs(Flex, {
          justifyContent: "space-between",
          marginBlockEnd: "200",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.filters.panelTitle"
            })
          }), /*#__PURE__*/_jsx(IconButton, {
            onClick: onClose,
            use: "transparent",
            padding: "0",
            marginInlineEnd: "-200",
            children: /*#__PURE__*/_jsx(RemoveIcon, {
              size: "300"
            })
          })]
        }), /*#__PURE__*/_jsx(FilterPanelContent, {})]
      })
    })
  });
}
function FilterPanelContent() {
  const {
    mobile
  } = useResponsiveProps({
    mobile: {
      xs: true,
      lg: false
    }
  });
  const {
    ProductType,
    Installed
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    children: [mobile && /*#__PURE__*/_jsx(PortalInstallableFilter, {}), mobile && /*#__PURE__*/_jsx(BreezeFilter, {}), /*#__PURE__*/_jsx(SelectFilter, {
      filter: ProductType
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: Installed
    }), /*#__PURE__*/_jsx(AppFilterControls, {}), /*#__PURE__*/_jsx(AgentFilterControls, {})]
  });
}